import { PropsWithChildren, createContext, useContext, useState } from 'react';
import { Outlet } from 'react-router-dom';

// SelectBranchDrawer

// ! CONTEXT LOGIC HOOK
const useSelectBranchDrawerLogic = () => {
	const [openSelectBranchesDrawer, setOpenSelectBranchesDrawer] = useState<boolean>(false);

	const openDrawer = () => setOpenSelectBranchesDrawer(true);
	const closeDrawer = () => setOpenSelectBranchesDrawer(false);

	return { openSelectBranchesDrawer, openDrawer, closeDrawer };
};

// ! CONTEXT
type ISelectBranchDrawerContextData = ReturnType<typeof useSelectBranchDrawerLogic>;
const SelectBranchDrawerContext = createContext<ISelectBranchDrawerContextData | undefined>(undefined);

// ! CONTEXT PROVIDER
export const SelectBranchDrawerProvider = ({ children = <Outlet /> }: PropsWithChildren) => {
	const value = useSelectBranchDrawerLogic();

	return <SelectBranchDrawerContext.Provider value={value}>{children}</SelectBranchDrawerContext.Provider>;
};

// ! CONTEXT CONSUMER HOOK
export const useSelectBranchDrawer = () => {
	const ctx = useContext(SelectBranchDrawerContext);

	if (!ctx) {
		throw new Error('useSelectBranchDrawer must be used inside SelectBranchDrawerProvider');
	}

	return ctx;
};
